import React, { useEffect } from 'react';
import { FormProvider } from 'react-hook-form';
import { observer } from 'mobx-react';
import { useBookingDateValidation } from '../shared/validation/useBookingDateValidation';
import { useParkingProductValidation } from '../shared/validation/useParkingProductValidation';
import { useStateValidation } from '../shared/validation/useStateValidation';
import { useExtrasSubmit } from './helpers/useExtrasSubmit';
import { useExtrasForm } from './helpers/useExtrasForm';
import { ExtrasLayout } from './ExtrasLayout';
import { logError } from '../../../../shared/error/logError';
import { usePrefetchEffect } from '../../../../shared/router/usePrefetchEffect';

interface IExtrasProps {
	nextUrl: string;
}

export const Extras = observer(({ nextUrl }: IExtrasProps) => {
	useStateValidation([
		useBookingDateValidation(),
		useParkingProductValidation(),
	]);

	const form = useExtrasForm();
	const onSubmit = useExtrasSubmit(nextUrl);

	usePrefetchEffect(nextUrl);

	useEffect(() => {
		// The user can't provide any 'invalid' data, so when there are any errors they indicate a bug, and need to be logged
		if (Object.keys(form.formState.errors).length) {
			logError(new Error('Invalid Extras form data'), {
				errors: form.formState.errors,
				values: form.getValues(),
			});
		}
	}, [form.formState.errors]);

	return (
		<>
			<FormProvider {...form}>
				<form onSubmit={form.handleSubmit(onSubmit)}>
					<ExtrasLayout />
				</form>
			</FormProvider>
		</>
	);
});
